export const range = (size, startAt = 0) => {
  try {
    return [...Array(size).keys()].map((i) => i + startAt);
  } catch (error) {
    return [];
  }
};
